(function () {
  "use strict";
  function init(root) {
    if (!root || root.getAttribute("data-gbg-ready")) return;
    root.setAttribute("data-gbg-ready", "1");
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector("[data-gbg-config]").textContent); } catch (e) {}
    var T = cfg.copy || {};
    var form = root.querySelector("[data-gbg-form]");
    var btn = root.querySelector("[data-gbg-submit]");
    var err = root.querySelector("[data-gbg-error]");
    var fieldErrs = [["gbg-other-text", "gbg-err-other"], ["gbg-q2", "gbg-err-q2"], ["gbg-q3", "gbg-err-q3"], ["gbg-q4", "gbg-err-q4"], ["gbg-q5", "gbg-err-q5"], ["gbg-first-name", "gbg-err-fname"], ["gbg-email", "gbg-err-email"], ["gbg-optin-email", "gbg-err-optmail"]];
    var otherText = root.querySelector("#gbg-other-text");
    var extraQs = [["q2_frustration", "#gbg-q2"], ["q3_look_for", "#gbg-q3"], ["q4_almost_stopped", "#gbg-q4"], ["q5_describe", "#gbg-q5"]]
      .map(function (p) { return [p[0], root.querySelector(p[1])]; }).filter(function (p) { return p[1]; });
    function val(f) { return ((f && f.value) || "").trim(); }
    var fname = root.querySelector("#gbg-first-name");
    var email = root.querySelector("#gbg-email");
    var optin = root.querySelector("#gbg-optin");
    var optMail = root.querySelector("#gbg-optin-email");
    var thanksH = root.querySelector("[data-gbg-thanks-heading]");
    var mode = "free";
    var kx = null;

    function readKx() {
      try {
        var q = new URLSearchParams(window.location.search).get("_kx");
        if (q) return q;
      } catch (e) {}
      try {
        var parts = document.cookie.split("; ");
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].indexOf("__kla_id=") === 0) {
            var j = JSON.parse(atob(decodeURIComponent(parts[i].slice(9))));
            return j.$exchange_id || j.exchange_id || null;
          }
        }
      } catch (e) {}
      return null;
    }
    function entered() { try { return !!localStorage.getItem("gbg-entered"); } catch (e) { return false; } }
    function markEntered() { try { localStorage.setItem("gbg-entered", new Date().toISOString()); } catch (e) {} }
    function savedCode() { try { var c = JSON.parse(localStorage.getItem("gbg-code") || "null"); return c && c.code && (!c.ends_at || new Date(c.ends_at) > new Date()) ? c : null; } catch (e) { return null; } }
    function saveCode(c) { try { localStorage.setItem("gbg-code", JSON.stringify(c)); } catch (e) {} }
    function showCode(c) {
      if (!c || !/^[A-Z0-9-]{6,40}$/.test(c.code || "")) return;
      var box = root.querySelector("[data-gbg-code]"), val = root.querySelector("[data-gbg-code-value]");
      if (box && val) { val.textContent = c.code; box.hidden = false; }
      var sub = root.querySelector("[data-gbg-recs-sub]");
      if (sub && T.recs_sub_code) sub.textContent = T.recs_sub_code;
      Array.prototype.forEach.call(root.querySelectorAll("[data-gbg-rec]"), function (a) {
        var path = a.getAttribute("data-path") || "/";
        a.setAttribute("href", "/discount/" + encodeURIComponent(c.code) + "?redirect=" + encodeURIComponent(path));
      });
      var again = root.querySelector("[data-gbg-gift-again]"), av = root.querySelector("[data-gbg-code-value-again]");
      if (again && av) { av.textContent = c.code; again.hidden = false; }
    }
    function fetchCode(identity) {
      if (!cfg.codeEndpoint) return;
      var have = savedCode(); if (have) { showCode(have); return; }
      if (!cfg.liveSubmit) { showCode({ code: "GBTHANKS-PREVIEW" }); return; }
      fetch(cfg.codeEndpoint, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(identity) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.code) return;
          saveCode(c); showCode(c);
          try {
            var prof = identity.kx ? { _kx: identity.kx } : { email: identity.email };
            prof.properties = { giveaway_instant_code: c.code, giveaway_instant_code_ends: c.ends_at || "" };
            fetch(cfg.endpoint, { method: "POST", headers: { "content-type": "application/vnd.api+json", "revision": cfg.revision }, body: JSON.stringify({ data: { type: "event", attributes: { properties: { code: c.code, ends_at: c.ends_at || "" }, metric: { data: { type: "metric", attributes: { name: "Giveaway Instant Code Issued" } } }, profile: { data: { type: "profile", attributes: prof } }, unique_id: "gbgc-" + c.code } } }) }).catch(function () {});
          } catch (x) {}
        }, function () {});
    }

    function setState(s) {
      root.setAttribute("data-state", s);
      root.classList.toggle("gbg--free", s === "free" || (s === "error" && mode === "free"));
      if (err) err.classList.toggle("is-on", s === "error");
      if (s === "thanks" || s === "already") { try { window.scrollTo(0, 0); } catch (e) {} }
    }
    function choices() { return Array.prototype.map.call(form.querySelectorAll('input[name="reasons"]:checked'), function (c) { return c.value; }); }
    function openText() { return (otherText.value || "").trim(); }
    function say(msg, field) {
      fieldErrs.forEach(function (p) {
        var f = document.getElementById(p[0]), m = document.getElementById(p[1]);
        if (m) m.textContent = "";
        if (f) f.removeAttribute("aria-invalid");
      });
      if (!msg || !field) return;
      var el = document.getElementById(field.getAttribute("aria-describedby"));
      if (!el) return;
      el.textContent = msg;
      field.setAttribute("aria-invalid", "true");
      try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); }
      try {
        var fr = field.getBoundingClientRect(), er = el.getBoundingClientRect(), vh = window.innerHeight, d = 0;
        var room = Math.min(120, Math.round(vh * 0.15));
        if (er.bottom > vh - 8) d = Math.min(er.bottom - vh + 16, fr.top - room);
        else if (fr.top < room) d = fr.top - room;
        if (d) {
          var de = document.documentElement, was = de.style.scrollBehavior;
          de.style.scrollBehavior = "auto";          /* the theme sets smooth scrolling; the message must be in view at once */
          window.scrollBy(0, d);
          de.style.scrollBehavior = was;
        }
      } catch (e) {}
    }

    function optEmail() { return ((mode === "free" ? email.value : optMail.value) || "").trim(); }
    function applyOptInDefault() {
      if (!optin) return;
      optin.checked = mode === "free" ? cfg.optInCheckedFree !== false : !!cfg.optInCheckedIdentified;
      root.classList.toggle("gbg--optin", optin.checked);
    }
    if (optin) optin.addEventListener("change", function () { root.classList.toggle("gbg--optin", optin.checked); say(""); });
    form.addEventListener("change", function (e) {
      if (e.target && e.target.name === "reasons") say("");
    });
    otherText.addEventListener("input", function () { say(""); });
    extraQs.forEach(function (p) { p[1].addEventListener("input", function () { say(""); }); });
    [fname, email, optMail].forEach(function (f) { if (f) f.addEventListener("input", function () { say(""); }); });

    function payload() {
      var r = choices();
      var now = new Date().toISOString();
      var identity = mode === "identified" && kx ? { _kx: kx } : { email: (email.value || "").trim(), first_name: (fname.value || "").trim() };
      var ot = openText();
      identity.properties = { purchase_reasons: r, purchase_reason_other: ot, giveaway_entered_at: now };
      var props = { reasons: r, reason_count: r.length, other_text: ot, question_version: mode === "identified" ? "buyer" : "free", source: mode === "identified" ? "email" : "free_entry", marketing_opt_in: !!(optin && optin.checked) };
      if (extraQs.length === 4) {
        props.question_set = "five-2026-10-26";
        extraQs.forEach(function (p) { props[p[0]] = val(p[1]); });
      }
      return {
        data: {
          type: "event",
          attributes: {
            properties: props,
            metric: { data: { type: "metric", attributes: { name: "Answered Purchase Question" } } },
            profile: { data: { type: "profile", attributes: identity } },
            time: now,
            unique_id: "gbg-" + Date.now() + "-" + Math.random().toString(36).slice(2, 8)
          }
        }
      };
    }
    function subscription() {
      if (!(optin && optin.checked)) return null;
      var attrs = { email: optEmail(), subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
      if (mode === "identified" && kx) attrs._kx = kx;
      return {
        data: {
          type: "subscription",
          attributes: { custom_source: "Giveaway entry page", profile: { data: { type: "profile", attributes: attrs } } },
          relationships: { list: { data: { type: "list", id: cfg.optInListId || "LIST_ID_NOT_SET" } } }
        }
      };
    }
    function done(p) {
      markEntered();
      var fn = mode === "free" ? (fname.value || "").trim() : "";
      if (thanksH) thanksH.textContent = fn ? (T.thanks_heading_named || "").replace("{first_name}", fn) : (T.thanks_heading || "");
      setState("thanks");
      fetchCode(mode === "identified" && kx ? { kx: kx } : { email: (email.value || "").trim().toLowerCase(), first_name: fn });
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!/[A-Za-z0-9]/.test(openText())) { say(T.err_choose, otherText); return; }
      for (var qi = 0; qi < extraQs.length; qi++) {
        if (!/[A-Za-z0-9]/.test(val(extraQs[qi][1]))) { say(T.err_choose, extraQs[qi][1]); return; }
      }
      if (mode === "free") {
        if (!(fname.value || "").trim()) { say(T.err_name, fname); return; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email.value || "").trim())) { say(T.err_email, email); return; }
      }
      if (mode === "identified" && optin && optin.checked && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(optEmail())) { say(T.err_email_optin, optMail); return; }
      say("");
      var p = payload();
      var sub = subscription();
      btn.disabled = true; btn.textContent = T.sending || "";
      if (!cfg.liveSubmit) {
        var rec = { event: p, marketing_opt_in: !!(optin && optin.checked), subscription_request: sub };
        try { console.log("[gbg stub] would POST", cfg.endpoint, JSON.stringify(rec)); } catch (x) {}
        window.gbgLastPayload = rec;
        btn.disabled = false; btn.textContent = T.submit || "";
        done(p); return;
      }
      fetch(cfg.endpoint, { method: "POST", headers: { "content-type": "application/vnd.api+json", "revision": cfg.revision }, body: JSON.stringify(p) })
        .then(function (res) {
          btn.disabled = false; btn.textContent = T.submit || "";
          if (res.status === 202 || res.ok) {
            if (sub && cfg.optInListId) {
              fetch(cfg.subscribeEndpoint, { method: "POST", headers: { "content-type": "application/vnd.api+json", "revision": cfg.revision }, body: JSON.stringify(sub) }).catch(function () {});
            }
            done(p);
          } else { btn.textContent = T.error_retry || T.submit; setState("error"); }
        }, function () {
          btn.disabled = false; btn.textContent = T.error_retry || T.submit; setState("error");
        });
    });

    var copyBtn = root.querySelector("[data-gbg-code-copy]");
    if (copyBtn) copyBtn.addEventListener("click", function () {
      var v = (root.querySelector("[data-gbg-code-value]") || {}).textContent || "";
      var ok = function () { copyBtn.textContent = T.code_copied || copyBtn.textContent; setTimeout(function () { copyBtn.textContent = T.code_copy || copyBtn.textContent; }, 2500); };
      try { navigator.clipboard.writeText(v).then(ok, function () {}); } catch (e) {}
    });

    kx = readKx();
    mode = kx ? "identified" : "free";
    applyOptInDefault();
    setState(entered() && !cfg.ignoreEntered ? "already" : mode);
    if (entered()) showCode(savedCode());

    root.gbgSetState = function (s) {
      if (s === "identified" || s === "free") { mode = s; applyOptInDefault(); }
      if (s === "error") { btn.textContent = T.error_retry || T.submit; } else { btn.textContent = T.submit || ""; }
      if (s === "thanks" && thanksH) thanksH.textContent = (T.thanks_heading_named || "").replace("{first_name}", "Linda");
      setState(s);
      if (s === "thanks" && arguments[1] && arguments[1].code) showCode(arguments[1]);
    };
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll("[data-gbg]"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
